module.exports = __webpack_public_path__ + "img/yellowChrysanthemum.9a77547e.jpg";